import type { VisibilityScope, TaskBucket } from "@/services/api/agentic-v2";
import { missionListFocusWindowParams } from "@/navigation/apps/missionControlLocation";

/** Caseload scope used when highlighting a mission row from agent/search navigation. */
export const MISSION_LIST_FOCUS_VISIBILITY: VisibilityScope = "all";

export function isMissionListFocusKey(focus: string | null | undefined): boolean {
  return Boolean(focus?.startsWith("mission:"));
}

export function missionIdFromListFocusKey(focus: string | null | undefined): string | null {
  if (!isMissionListFocusKey(focus)) {
    return null;
  }
  const id = focus!.slice("mission:".length).trim();
  return id || null;
}

/** OS window / URL params for Mission Control missions-tab list highlight. */
export function missionListFocusParams(focusKey: string): Record<string, string> {
  return missionListFocusWindowParams(focusKey);
}

export function parseMissionControlVisibility(
  value: string | null | undefined,
): VisibilityScope | null {
  if (value === "me" || value === "team" || value === "all") {
    return value;
  }
  return null;
}

const TASK_BUCKETS: TaskBucket[] = [
  "needs_me",
  "blocked",
  "needs_review",
  "working",
  "in_progress",
  "queued",
  "recent",
  "all",
];

export function parseMissionControlTaskBucket(
  value: string | null | undefined,
): TaskBucket | null {
  if (value && TASK_BUCKETS.includes(value as TaskBucket)) {
    return value as TaskBucket;
  }
  return null;
}

/** OS window / URL params for Mission Control tasks-tab list highlight. */
export function taskListFocusParams(focusKey: string): Record<string, string> {
  return missionListFocusWindowParams(focusKey);
}
